export enum NumberWithUnitPeerField {
    UNIT = "_um",
    FUNCTIONAL_NUMBER = "_fnu",
    FUNCTIONAL_UNIT = "_fum"
}
